import React from "react";
// import "./App.css";
import SpotifyWebApi from "spotify-web-api-js";
import axios from "axios";


function SpotApi() {
  //   axios
  //     .post("https://accounts.spotify.com/api/token", {
  //       headers: {
  //         Authorization:"",
  //       },
  //       params: {
  //         grant_type: "client_credentials",
  //         // 
  //         // 
  //       },
  //     })
  //     .then(function (response) {
  //       console.log(response);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });

  
  // var spotifyApi = new SpotifyWebApi();

  // spotifyApi.setAccessToken(
  //   ""
  // );

  // spotifyApi.searchArtists("taylor swi").then(
  //   function (data) {
  //     console.log("Search artists by ", data);
  //   },
  //   function (err) {
  //     console.error(err);
  //   }
  // );

  return <div></div>;
}

export default SpotApi;
